import Axios from "../../../../../api/axios/Axios";

export const recordPopView = async (popId, data = {}) => {
  const response = await Axios.post(`/api/users/pops/${popId}/view`, data);

  return response.data;
};

export const getPopViewCounts = async (popIds = []) => {
  const response = await Axios.get("/api/users/pops/views", {
    params: {
      popIds: popIds.join(","),
    },
  });
  return response.data;
};

export const getPopViewCount = async (popId) => {
  const response = await Axios.get(`/api/users/pops/${popId}/views`);
  return response.data;
};
